import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MapPin } from "lucide-react";

export function DeliveryAddressSection({ form, setForm }) {
  return (
    <div>
      <div className="flex items-center gap-2">
        <Switch
          checked={form.different_delivery_address || false}
          onCheckedChange={v => setForm(prev => ({ ...prev, different_delivery_address: v }))}
          data-testid="doc-delivery-switch"
        />
        <MapPin size={14} className="text-slate-400" />
        <Label className="text-sm">Adresse de livraison différente</Label>
      </div>
      {form.different_delivery_address && (
        <div className="mt-2 p-3 bg-slate-50 rounded-md border border-slate-200 space-y-2">
          <div>
            <Input
              placeholder="Adresse de livraison"
              value={form.delivery_address || ""}
              onChange={e => setForm(prev => ({ ...prev, delivery_address: e.target.value }))}
              data-testid="doc-delivery-address"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
            <Input placeholder="Code postal" value={form.delivery_postal_code || ""} onChange={e => setForm(prev => ({ ...prev, delivery_postal_code: e.target.value }))} data-testid="doc-delivery-postal" />
            <Input placeholder="Ville" value={form.delivery_city || ""} onChange={e => setForm(prev => ({ ...prev, delivery_city: e.target.value }))} data-testid="doc-delivery-city" />
            <Input placeholder="Pays" value={form.delivery_country || ""} onChange={e => setForm(prev => ({ ...prev, delivery_country: e.target.value }))} data-testid="doc-delivery-country" />
          </div>
        </div>
      )}
    </div>
  );
}
